import React from "react"
import { TextSmall } from "@mallardbay/lib-react-components"

import ImageCard from "~components/shared/todo-lib-react-components/image-card/image-card"
import type {
    OutfitterLodgingFieldsFragment,
    PublicLodgingFieldsFragment,
} from "~graphql/generated/graphql"
import { formatCapacity } from "~utils/lodging-helpers"

interface Props {
    readonly lodging:
        | OutfitterLodgingFieldsFragment
        | PublicLodgingFieldsFragment

    readonly handleClick: (
        lodging: Omit<OutfitterLodgingFieldsFragment, "__typename">
    ) => void
}

export default function LodgeImageCard({ lodging, handleClick }: Props) {
    return (
        <ImageCard
            title={lodging.name}
            headerImageSrc={lodging.cover_image}
            headerImageRatio={3 / 2}
            onClick={() => handleClick(lodging)}
        >
            <TextSmall>{formatCapacity(lodging)}</TextSmall>
        </ImageCard>
    )
}
